import './instrumentation/sentry';
import * as Sentry from '@sentry/react';
import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';
import ChatWidgetProvider from 'providers/ChatWidgetProvider';
import { RootStoreProvider } from '../src/app/shared/+state/+root/root.provider';
import { ToastsContainer } from './components/Toasts/Toasts';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      beforeCapture={scope => {
        scope.setTag('errorBoundary', 'root');
        scope.setContext('react', { errorBoundary: 'root' });
      }}
      fallback={({ error, resetError, eventId }) => (
        <div className="p-5 text-center">
          <h1 className="h4 mb-3">Something went wrong</h1>
          <p className="text-body-secondary small mb-2">
            {error instanceof Error ? error.message : 'Please refresh the page.'}
          </p>
          {eventId ? (
            <p className="text-muted small mb-3">
              Reference: <code>{eventId}</code>
            </p>
          ) : null}
          <button type="button" className="btn btn-primary btn-sm" onClick={resetError}>
            Try again
          </button>
        </div>
      )}
    >
      <AppProvider>
        <RootStoreProvider>
          <SettingsPanelProvider>
            <ToastsContainer />
            <ChatWidgetProvider>
              <BreakpointsProvider>
                <RouterProvider router={router} />
              </BreakpointsProvider>
            </ChatWidgetProvider>
          </SettingsPanelProvider>
        </RootStoreProvider>
      </AppProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
